import React, { useCallback, useState } from 'react';
import {
  IQualificationsOpenStepsContext,
  QualificationsOpenStepsContext,
} from '../../../services/contexts';

export const QulificationsOpenStepsProvider: React.FC<{ children: any }> = ({ children }) => {
  const [stepOne, setStepOne] = useState(true);
  const [stepTwo, setStepTwo] = useState(false);
  const setSteps = useCallback(
    (one?: boolean, two?: boolean) => {
      setStepOne(one || !stepOne);
      setStepTwo(two || !stepTwo);
    },
    [stepOne, stepTwo]
  );
  const value: IQualificationsOpenStepsContext = {
    showStepOne: stepOne,
    showStepTwo: stepTwo,
    setSteps,
  };
  return (
    <QualificationsOpenStepsContext.Provider value={value}>
      {children}
    </QualificationsOpenStepsContext.Provider>
  );
};
